<template>
    <el-dialog title="常用模板" :close-on-click-modal="false" :visible.sync="visible" width="55%">
        <el-table :data="chunkedTemplateList" :show-header="false" border style="width: 90%;margin:0 50px 50px 50px">
            <el-table-column v-for="(col, colIndex) in 3" :key="colIndex">
                <template slot-scope="scope">
                    <div v-if="scope.row[colIndex]" class="template-item">
                        <span class="template-name download-link"
                            @click="downloadTemplate(scope.row[colIndex].recno, scope.row[colIndex].templateName)">
                            {{ scope.row[colIndex].templateName }}
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
    name: "file-template",
    data() {
        return {
            visible: false,
            inline: false,
            templateList: []
        }
    },
    computed: {
        chunkedTemplateList() {
            const chunkSize = 3;
            const result = [];
            for (let i = 0; i < this.templateList.length; i += chunkSize) {
                result.push(this.templateList.slice(i, i + chunkSize));
            }
            return result;
        }
    },
    methods: {
        init() {
            this.visible = true;
            this.getFileTemplateList();
        },
        getFileTemplateList() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/filetemplate/list/" + $common.getItem("workNo"),
                method: 'get',
                params: this.$http.adornParams({
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.templateList = data.body;
                }
            })
        },
        downloadTemplate(recno, filename) {
            filename = filename + '模版文件'

            this.$http({
                url: this.$store.state.httpUrl + "/business/filetemplate/downloadTemplate",
                method: 'get',
                params: this.$http.adornParams({
                    workNo: $common.getItem("workNo"),
                    recno: recno
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    filename = this.getSuffix(data.body, filename)
                    this.getBlob(data.body, (blob) => {
                        this.saveAs(blob, filename)
                    })
                }
            })
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
    }
}
</script>
<style scoped>
.template-item {
    padding: 2px;
    text-align: center;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.download-link {
    color: #409EFF;
    cursor: pointer;
}

.download-link:hover {
    color: #66b1ff;
}

.no-file {
    color: #909399;
    font-style: italic;
}
</style>